export enum SettingsFontSizes {
  fontSize1 = '100',
  fontSize2 = '150',
  fontSize3 = '200',
}
